import React, {useState, useEffect} from "react";
import { Navigate } from 'react-router-dom';
import {Col, Modal, Row, Spinner} from "react-bootstrap";
import {Formik, Form} from "formik";
import * as yup from 'yup';
import moment from "moment";

import Header from "../../components/Header/Header";
import Stepper from "../../components/Stepper/Stepper";

import styles from './SampleDataPage.module.css';

import InputSampleSection from "./InputSampleSection";
import UploadDocumentSection from "./UploadDocumentSection";
import ReviewSection from "./ReviewSection";

import * as apiSupplierOnboard from '../../apis/supplierOnboard';
import { FINAL_STATUS_PENDING, FINAL_STATUS_NEED_REUPLOAD } from "../../constants/finalStatus";
import { REGISTRATION_STATUS_APPROVED } from "../../constants/registrationStatus";

const SampleDataPage = (props) => {
    const [activeStep, setActiveStep] = useState(1);
    const [submittedSampleId, setSubmittedSampleId] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const [supplierOnboard, setSupplierOnboard] = useState();

    useEffect(() => {        
        let subs = window.location.pathname.split("/");
        
        const fetchData = async () => {
            const supplierOnboardPromise = apiSupplierOnboard.getByRegistrationCode({registrationCode: subs.pop()});
            const [supplierOnboardResponse] = await Promise.all([
                supplierOnboardPromise,
            ]);
            setSupplierOnboard(supplierOnboardResponse.data.data);
            setIsLoading(false);
        }
        fetchData().catch(console.error);

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [])

    const handleBeforeUnload = (e) => {
        e.preventDefault();
        const message =
          "Custom confirmation message.";
        e.returnValue = message;
        return message;
      };
      
    const steps = [
        {label: 1, content: 'Isi Data Sampel'},
        {label: 2, content: 'Upload Dokumen '},
        {label: 3, content: 'Review'},
    ]

    const stepForward = () => {
        setActiveStep(activeStep + 1);
    }

    const stepBack = () => {
        setActiveStep(activeStep - 1);
    }

    const renderSection = (formikProps, currentStep, onSubmitSample) => {
        const sections = {
            1: <InputSampleSection {...formikProps} forward={stepForward}/>,
            2: <UploadDocumentSection {...formikProps} forward={stepForward} back={stepBack}/>,
            3: <ReviewSection {...formikProps} back={stepBack} onSubmit={onSubmitSample}/>
        }

        return sections[currentStep];
    }

    const uploadDocuments = (values) => {
        try {
            values.documents
            .filter((doc) => { return doc !== undefined})
            .forEach(async (doc) => {
                if (doc) {
                    const formData = new FormData();
                    formData.append("document", doc.file);
                    formData.append("type", doc.type);

                    const docRes = await apiSupplierOnboard.uploadDocument({
                        supplierOnboardId: supplierOnboard.id,
                        data: formData
                    });

                    if (!docRes.data) {
                        console.log(docRes.data.message);
                        return;
                    }
                }
            });
        } catch (e) {
            console.log(e.message);
            return null;
        }
    }

    const onSubmitSample = async (values) => {
        let requestBody = {
            deliveryTime: values.deliveryTime,
            warehouseId: values.warehouseId,
            sampleItems: values.sampleItems
        }

        try {
            const sampleRes = await apiSupplierOnboard.createSample({supplierOnboardId: supplierOnboard.id, data: requestBody});
            if (!sampleRes.data) {
                console.log(sampleRes.data.message);
                return;
            }
            uploadDocuments(values);
            setSubmittedSampleId(sampleRes.data.data.id);
        } catch (e) {
            console.log(e.message);
            return null;
        }
    }

    const validationSchema = yup.object().shape({
        deliveryTime: yup.date()
            .typeError('Gagal menentukan data Waktu Pengiriman')
            .min(new moment(Date()).add(24, 'hours').format('YYYY-MM-DDTHH:mm'), 'Waktu pengiriman harus berjarak minimal 24 jam dari waktu saat ini!')
            .required('Waktu pengiriman harus terisi'),
        warehouseId: yup.number()
            .typeError('Gagal menentukan data Warehouse Tujuan').required('Warehouse tujuan harus terisi'),
        sampleItems: yup.array()
            .of(
                yup.object().shape({
                    itemName: yup.string().required('Nama barang harus terisi'),
                    quantity: yup
                        .number()
                        .typeError('Qty harus berupa angka dan lebih besar dari 0')
                        .not([0], 'Qty harus lebih besar dari 0')
                        .required('Qty harus terisi'),
                    unit: yup.string().required('Unit harus terisi')
                })
            )
            .min(1)
    });

    if (submittedSampleId) {
        return <Navigate to={'/sample-submitted/' + submittedSampleId} replace={true} />
    }
    
    if (!supplierOnboard) {
        return <div className={styles.container}>
        <Header activeKey="/" />
        <div className={styles.pageBody}>
            {isLoading && 
                <Spinner className="mx-auto d-block"
                animation="border" size="lg" />
            }
            {!isLoading &&
            <Row>
                <Col lg={12}>
                    <div className={[styles.confirmationCard, styles.textArea]}>
                        <p>Data supplier tidak ditemukan!</p>
                    </div>
                </Col>
            </Row>
            }
        </div>
    </div>
    } else {
        return <>
        <div className={styles.container}>
            <Header activeKey="/" />
            <div className={styles.pageBody}>
                {!isLoading && supplierOnboard.registrationStatus === REGISTRATION_STATUS_APPROVED && 
                (supplierOnboard.finalStatus === FINAL_STATUS_PENDING || supplierOnboard.finalStatus === FINAL_STATUS_NEED_REUPLOAD) &&
                <div className={'container my-4'}>
                    <Row>
                        <Col lg={4}>
                            <div className={styles.sectionCard}>
                                <Stepper steps={steps} isActive={activeStep}/>
                            </div>
                        </Col>
                        <Col lg={8} style={{height: '85vh', overflowY: 'scroll'}}>
                            <Formik 
                                validationSchema={validationSchema}
                                initialValues={{
                                    deliveryTime: null,
                                    deliveryTimeString: null,
                                    warehouseId: null,
                                    warehouseName: null,
                                    warehouseAddress: null,
                                    sampleItems: [{itemName: '', quantity: 0, unit: ''}],
                                    documents: []
                                }}
                                onSubmit={onSubmitSample}
                            >
                                {(formikProps) => 
                                    renderSection(formikProps, activeStep, onSubmitSample)}
                            </Formik>
                        </Col>
                    </Row>
                </div>
                }
                {!isLoading && (supplierOnboard.finalStatus !== FINAL_STATUS_PENDING && supplierOnboard.finalStatus !== FINAL_STATUS_NEED_REUPLOAD) &&
                <Row>
                    <Col lg={12}>
                        <div className={[styles.confirmationCard, styles.textArea]}>
                            <p>Silakan cek status pendaftaran terlebih dahulu!</p>
                        </div>
                    </Col>
                </Row>
                }
            </div>
        </div>
    </>
    }
}

export default SampleDataPage;